var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tour-info-box"},[_c(_vm.icon,{tag:"component",staticClass:"icon"}),_c('div',{staticClass:"tour-info-box__info"},[_c('h6',{staticClass:"tour-info-box__info--title font-14"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"tour-info-box__info--text font-12"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }